import { api } from 'src/api/axios';
import { HealthIssueDetail, HealthCondition, DrugInfo, MedicationSearchResult, DosageOption } from './interfaces/health';
import { Issue } from 'src/services/interfaces/application';
import { aiApi } from '@api/ai-axios';

export const healthService = {
  getIssueDetails: async (): Promise<HealthIssueDetail[]> => {
    const response = await api.get<HealthIssueDetail[]>('/health/issue-details');
    return response.data;
  },

  createIssueDetail: async (data: HealthIssueDetail): Promise<HealthIssueDetail> => {
    const response = await api.post<HealthIssueDetail>('/health/issue-details', data);
    return response.data;
  },

  getIssueDetail: async (id: number): Promise<HealthIssueDetail> => {
    const response = await api.get<HealthIssueDetail>(`/health/issue-details/${id}`);
    return response.data;
  },

  updateIssueDetail: async (id: number, data: HealthIssueDetail): Promise<HealthIssueDetail> => {
    const response = await api.patch<HealthIssueDetail>(`/health/issue-details/${id}`, data);
    return response.data;
  },

  deleteIssueDetail: async (id: number): Promise<void> => {
    await api.delete(`/health/issue-details/${id}`);
  },

  getConditions: async (): Promise<HealthCondition[]> => {
    const response = await api.get<HealthCondition[]>('/health/conditions');
    return response.data;
  },

  createCondition: async (data: HealthCondition): Promise<HealthCondition> => {
    const response = await api.post<HealthCondition>('/health/conditions', data);
    return response.data;
  },

  getCondition: async (id: number): Promise<HealthCondition> => {
    const response = await api.get<HealthCondition>(`/health/conditions/${id}`);
    return response.data;
  },

  updateCondition: async (id: number, data: HealthCondition): Promise<HealthCondition> => {
    const response = await api.patch<HealthCondition>(`/health/conditions/${id}`, data);
    return response.data;
  },

  deleteCondition: async (id: number): Promise<void> => {
    await api.delete(`/health/conditions/${id}`);
  },

  getMedications: async (query: string, signal?: AbortSignal): Promise<MedicationSearchResult[]> => {
    const response = await aiApi.get<MedicationSearchResult[]>('/medications/', { 
      params: { q: query },
      signal,
    });
    return response.data;
  },

  getMedicationDosages: async (medicationId: string, signal?: AbortSignal): Promise<DosageOption[]> => {
    const response = await aiApi.get<DosageOption[]>(`/medications/${medicationId}/dosages`, {
      signal,
    });
    return response.data;
  },

  getIssues: async (): Promise<Issue[]> => {
    const response = await api.get<Issue[]>('/health/issues');
    return response.data;
  },
};